// Single source of truth for the backend API base URL.
//
// We deliberately prefer SAME-ORIGIN over `process.env.REACT_APP_BACKEND_URL`
// when running in a real browser. Reasoning:
//
// 1. Both our preview deploy (*.preview.emergentagent.com) AND production
//    (karmakundali.org) serve `/api/*` on the SAME origin via the K8s
//    ingress — the env var is functionally redundant in the browser.
// 2. We have been bitten in production by a stale REACT_APP_BACKEND_URL
//    pointing at a backend hostname (mystic-maliha.emergent.host) whose
//    /api routes started 404'ing. Using `window.location.origin` makes the
//    frontend self-healing — wherever it is loaded, it talks back to that
//    same origin's `/api/*`.
// 3. The env var is only used as a fallback for non-browser contexts
//    (build-time scripts, SSR, tests) where `window` is undefined.
const ENV_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export const API_BASE = (() => {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return ENV_URL;
})();

export default API_BASE;
